import { register, getPrefix } from '../../../Utils'
import mapStyles from './MapStyles'

const LocationMap = el => {
  let map
  let google = window.google
  let MarkerClusterer = window.MarkerClusterer

  const prefix = getPrefix(el)
  const locations = JSON.parse(el.dataset.locations)
  const mapMessage = el.querySelector(`.${prefix}map-message`)
  const searchInput = el.querySelector(`.${prefix}search-input`)
  const markerImagePath = el.dataset.markerImage
  const allMarkers = []
  let markerCluster

  const initFilters = () => {
    const filterContainer = el.querySelector(`.${prefix}filters`)
    const filters = filterContainer.querySelectorAll(`.${prefix}filter`)
    let currentFilter
    let currentFilterId

    const clickFilter = (e) => {
      e.preventDefault()

      currentFilterId = +e.currentTarget.dataset.filterId === currentFilterId ? 0 : +e.currentTarget.dataset.filterId

      filters.forEach(filter => {
        filter.classList.toggle(`${prefix}active`, e.currentTarget === filter && e.currentTarget !== currentFilter)
      })

      currentFilter = currentFilter === e.currentTarget ? null : e.currentTarget

      filterItems()

      if (searchInput) {
        searchInput.value = ''
      }
    }

    filters.forEach(filter => {
      filter.addEventListener('click', clickFilter)
    })

    const filterItems = () => {
      allMarkers.forEach(marker => {
        if (currentFilterId) {
          marker.setVisible(marker.businessAreas && marker.businessAreas.includes(currentFilterId))
        } else {
          marker.setVisible(true)
        }
      })
      setBoundsToMarkers()
      google.maps.event.addListenerOnce(map, 'idle', () => {
        markerCluster.repaint()
      })
    }
  }

  const setBoundsToMarkers = () => {
    const mapBounds = new google.maps.LatLngBounds()

    allMarkers.forEach(marker => {
      if (marker.getVisible()) {
        mapBounds.extend(marker.getPosition())
      }
    })
    map.fitBounds(mapBounds, 0)
  }

  const initMap = () => {
    const mapContainer = el.querySelector(`.${prefix}map-container`)
    let activeTooltip

    map = new google.maps.Map(mapContainer, {
      center: new google.maps.LatLng(30, 0), // change later
      zoom: 2,
      maxZoom: 16,
      styles: mapStyles
    })

    const markerIcon = {
      url: markerImagePath,
      scaledSize: new google.maps.Size(15, 15),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(0, 0)
    }

    if (locations && typeof locations === 'object') {
      locations.forEach(location => {
        const tooltip = new google.maps.InfoWindow({
          content: `<div>${location.title ? `${location.title}<br>` : ''}${location.street ? `${location.street} ${location.streetNumber ? `${location.streetNumber}` : ''}<br>` : ''}${location.zip || location.city ? `${location.zip} ${location.city}<br>` : ''}${location.country ? `${location.country}<br>` : ''}<br>${location.phone ? `<a href="tel:${location.phone}">${location.phone}</a><br>` : ''}${location.fax ? `${location.fax}<br>` : ''}<br>${location.email ? `<a href="mailto:${location.email}">${location.email}</a><br>` : ''}${location.website ? `<a href="${location.website}" target="_blank">${location.website}</a>` : ''}</div>`
        })
        const mapMarker = new google.maps.Marker({
          position: { lat: +location.latitude, lng: +location.longitude },
          map: map,
          title: location.title,
          icon: markerIcon,
          businessAreas: location.businessAreas,
          countryCode: location.countryIsoCode
        })
        mapMarker.addListener('click', () => {
          if (activeTooltip) {
            activeTooltip.close()
          }
          tooltip.open(map, mapMarker)
          activeTooltip = tooltip
        })
        google.maps.event.addListener(map, 'click', () => {
          tooltip.close()
        })
        allMarkers.push(mapMarker)
      })

      markerCluster = new MarkerClusterer(map, allMarkers, { imagePath: markerImagePath, ignoreHidden: true })
    }
  }

  const changeMapByCountryCode = (counryCode) => {
    const geocoder = new google.maps.Geocoder()

    geocoder.geocode({
      componentRestrictions: {
        country: counryCode
      }
    }, (results, status) => {
      if (status === 'OK') {
        map.fitBounds(results[0].geometry.bounds, 0)
        const zoom = map.getZoom()
        map.setZoom(zoom < 3 ? 3 : zoom)
      } else {
        console.error('Geocode was not successful for the following reason: ' + status)
      }
    })
  }

  const initSearchFilter = () => {
    const searchOptions = {
      fields: ['address_components', 'geometry', 'name'],
      strictBounds: false,
      types: ['geocode']
    }

    const locationSearch = new google.maps.places.Autocomplete(searchInput, searchOptions)

    const changeLocationSearch = e => {
      const place = locationSearch.getPlace()

      // get country codes from only visible markers and remove duplicates
      const availableCountryCodes = [...new Set(allMarkers.reduce((result, marker) => {
        if (marker.getVisible()) {
          result.push(marker.countryCode)
        }
        return result
      }, []))]

      // hier ggf. noch Fehler abfangen, falls wirklich kein Land gibt o.Ä.
      const selectedCountryCode = place.address_components.find(addressComponent => addressComponent.types.includes('country')).short_name

      if (availableCountryCodes.includes(selectedCountryCode)) {
        changeMapByCountryCode(selectedCountryCode)
      } else {
        changeMapByCountryCode('CH')
        mapMessage.classList.add(`${prefix}is--visible`)
        window.setTimeout(() => {
          mapMessage.classList.remove(`${prefix}is--visible`)
        }, 5000)
      }
    }

    locationSearch.addListener('place_changed', changeLocationSearch)
  }

  initFilters()
  initMap()
  initSearchFilter()
}

register('LocationMap', LocationMap)
